import { AxiosResponse } from "axios";

import API from "../api";

import { Bookmark } from "../models/bookmark";

const ROUTE_NAME = "bookmarks";

const BookmarkService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Bookmark>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Bookmark[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(bookmark: Bookmark): Promise<AxiosResponse<Bookmark>> {
    return await API.post(`/${ROUTE_NAME}`, bookmark);
  },
  async update(id: number, bookmark: Bookmark): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, bookmark);
  },
  async delete(id: number): Promise<AxiosResponse<Bookmark>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default BookmarkService;
